<template>
  <div class="c-le-pages-nav">
    <div class="c-le-pages-nav__wrapper">
      <div class="c-le-pages-nav__next">
        <router-link :to="nextLink" class="c-le-pages-nav__next-link">
          <span class="c-le-pages-nav__next-label">
            {{ $t('LE_PAGES_NAV_NEXT') }}
          </span>
          <div class="c-le-pages-nav__next-card">
            <div v-if="nextImage" class="c-le-pages-nav__next-image">
              <img :src="addCloudinaryUrlParams(nextImage.file.url, 'w_110,c_scale')" :alt="nextImage.file.alternativeText" />
            </div>
            <div class="c-le-pages-nav__next-content">
              <h2 class="c-le-pages-nav__next-title">
                {{ nextTitle }}
              </h2>
              <div class="c-le-pages-nav__next-icon" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { addCloudinaryUrlParams } from '@/utils'

export default {
  name: 'LEPagesNav',

  props: {
    nextTitle: String,
    nextImage: Object,
    nextLink: String
  },

  data() {
    return {
      addCloudinaryUrlParams
    }
  }
}
</script>
